var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconawesomePhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.868,
    height: 26.868,
    viewBox: "0 0 26.868 26.868",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-phone",
    "data-name": "Icon awesome-phone",
    d: "M18.309.913,14.45.023a.9.9,0,0,0-1.02.516L11.648,4.694A.888.888,0,0,0,11.9,5.733l2.249,1.84a13.752,13.752,0,0,1-6.575,6.575L5.737,11.9A.89.89,0,0,0,4.7,11.644L.542,13.425A.9.9,0,0,0,.023,14.45l.891,3.859a.89.89,0,0,0,.868.69A17.215,17.215,0,0,0,19,1.782.889.889,0,0,0,18.309.913Z",
    transform: "translate(13.434 26.868) rotate(-135)",
    fill: "#ff5b5b"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomePhone);
export default __webpack_public_path__ + "static/media/Icon awesome-phone.bfdcd8de634d4dec19b12563422412df.svg";
export { ForwardRef as ReactComponent };